import { formatDateCustom } from "@app/shared/formatDateTime";
import { toast } from "react-toastify";

export const formatDate = (date: string): string =>
  formatDateCustom(date, "MM/DD/YY hh:mm A");

export const copyToClipboardWithToast = (value: string, label: string): Promise<void> =>
  navigator.clipboard.writeText(value).then(
    () => { toast.success(`Copied ${label}: ${value}`, { containerId: "z-index-9999" }); },
    () => { }
  );

export const formatDuration = (seconds: number): string => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h > 0) return `${h}h ${m}m ${s}s`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
};

export const compareWithNullsLast = (
  a: string | number | boolean | null,
  b: string | number | boolean | null,
  multiplier: number,
): number => {
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  if (typeof a === "string" && typeof b === "string") return a.localeCompare(b) * multiplier;
  return (Number(a) - Number(b)) * multiplier;
};

export const escapeCsvField = (value: string): string =>
  /[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;

export const toCsvString = (headers: string[], rows: string[][]): string =>
  [headers, ...rows].map((row) => row.map(escapeCsvField).join(",")).join("\r\n");

export const formatDateFile = (date: Date): string =>
  formatDateCustom(date, "YYYYMMDD_HHmmss");